module.exports = __webpack_public_path__ + "static/media/goldenprize-sardine-natural.c4a46192.png";